<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户id">
          <el-input v-model="formInline.user_id" placeholder="请输入用户id" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option label="有效" value="1"></el-option>
            <el-option label="无效" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="70">
            <template slot-scope="scope" v-if="scope.row.user">
              <img :src="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="关联题库">
            <template slot-scope="scope">
              <el-button size="mini" href="/" target="_blank" @click="onDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span class="" v-if="scope.row.status == 1">有效</span>
              <span class="gray9" v-else>无效</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import QuestionCollectApi from '@/api/study/question_collect.js';
  import qs from 'qs';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user_id: '',
          status: '',
          create_time: '',
        },
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*跳转详情*/
      onDetail(row) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let params = {question_id: row.record_id};
        baseUrl = this.$filter.isDebug() ? '' : '/shop';
        window.open(baseUrl + '/#/study/questionlibrary/index?' + qs.stringify(params));
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        QuestionCollectApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.totalDataNumber = data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/questioncollect/index.vue